/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S5_IntroInputs */

const tr_iletisim_s5_intro = /** @type {(inputs: Iletisim_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnership, entegrasyon ve kurumsal teklifler için:`)
};

const en_iletisim_s5_intro = /** @type {(inputs: Iletisim_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For partnership, integration and corporate offers:`)
};

const de_iletisim_s5_intro = /** @type {(inputs: Iletisim_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Partnerschaften, Integrationen und Unternehmensangebote:`)
};

const ru_iletisim_s5_intro = /** @type {(inputs: Iletisim_S5_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`По вопросам партнёрства, интеграции и корпоративных предложений:`)
};

/**
* | output |
* | --- |
* | "For partnership, integration and corporate offers:" |
*
* @param {Iletisim_S5_IntroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s5_intro = /** @type {((inputs?: Iletisim_S5_IntroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S5_IntroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s5_intro(inputs)
	if (locale === "de") return de_iletisim_s5_intro(inputs)
	if (locale === "ru") return ru_iletisim_s5_intro(inputs)
	return tr_iletisim_s5_intro(inputs)
});